import axios from "axios";

const formHeaders = {
  'Content-Type': 'application/json',
  // "Content-Type": "multipart/form-data",
  "Access-Control-Allow-Origin": "*",
};

const urlPath = "visitSheetCai";

export const getVisitSheetCai = async (id) => {
  try {
    const response = await axios.get(`${urlPath}/${id}`);

    return response;
  } catch (error) {
    console.log(error);
  }
};